import React from "react";
import { ProjectsList } from "./ProjectsList";

export default function index() {
  return (
    <div className="fade-in mt-4">
      <div className="md:mx-4 flex flex-wrap justify-center gap-4">
        {ProjectsList.map((project) => {
          return (
            <a
              key={project.name}
              href={project.projectLink}
              target="_blank"
              rel="noreferrer"
              className="group flex flex-col items-center justify-between py-6 px-2 md:px-4 w-[100%] max-h-[500px] max-w-[280px] md:max-w-[340px] rounded-lg cursor-pointer transition-all duration-300 hover:bg-neutral-900/50 hover:scale-[1.02]"
            >
              <div>
                <div className="aspect-video w-full mb-3 outline outline-1 rounded-lg outline-neutral-700 overflow-hidden transition-all duration-300 group-hover:outline-neutral-500">
                  {project.src && (
                    <img
                      alt={project.name}
                      className="w-full h-full object-cover object-top"
                      src={project.src}
                    />
                  )}

                  {project.loomLink && (
                    <iframe
                      title={project.name}
                      src={project.loomLink}
                      frameBorder="0"
                      allowFullScreen
                      className="w-full h-full pointer-events-auto"
                    ></iframe>
                  )}
                </div>
                <h3 className="text-base font-medium w-full">{project.name}</h3>
                <p className="text-gray-500 text-sm my-1.5 mx-auto leading-relaxed">
                  {project.description}
                </p>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span className="text-neutral-400 group-hover:text-white text-sm transition-all duration-300 py-2 flex items-center gap-2 group-hover:gap-3">
                  Live Demo
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(project.sourceLink, "_blank");
                  }}
                  className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-2 flex items-center gap-2 hover:gap-3"
                >
                  <i className="fa-brands fa-github"></i>
                  Source Code
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
